import api from "@/services/api";

export default {
  namespaced: true, // Name of namespace exists here '@/store/namespaces'
  state: {
    weeklyOutlooks: null,
    trsxnsByWkOutlook: {}, // Cache for transactions by week outlook ID
  },
  getters: {
    getWeeklyOutlooks: (state) => {
      return state.weeklyOutlooks;
    },
    getTransactionsByWeeklyOutlook: (state) => {
      return state.trsxnsByWkOutlook;
    },
  },
  mutations: {
    setWeeklyOutlooks: (state, weeklyOutlooks) => {
      state.weeklyOutlooks = weeklyOutlooks;
    },
    setTransactionsByWeeklyOutlook: (
      state,
      { weeklyOutlookId, transactions }
    ) => {
      state.trsxnsByWkOutlook[weeklyOutlookId] = transactions;
    },
  },
  actions: {
    async fetchWeeklyOutlooks(
      { commit, getters },
      { qryParams, force = false }
    ) {
      try {
        if (getters.getWeeklyOutlooks && !force) {
          // If we already have weekly outlooks in state and not forcing, we can skip the API call
          return;
        }

        const response = await api.get("/weekly-outlooks", {
          params: qryParams,
        });
        commit(
          "setWeeklyOutlooks",
          response.data.map((wo) => wo.item)
        );
      } catch (error) {
        console.error("Error fetching weekly outlooks:", error);
      }
    },
    async fetchTransactionsForWeeklyOutlook(
      { commit },
      { qryParams, weeklyOutlookId }
    ) {
      try {
        const response = await api.get("/weekly-outlooks/assignments", {
          params: qryParams,
        });
        commit("setTransactionsByWeeklyOutlook", {
          weeklyOutlookId,
          transactions: response.data.map((tx) => tx.item),
        });
      } catch (error) {
        console.error("Error fetching transactions for weekly outlook:", error);
      }
    },
  },
};
